import * as React from "react";
import {ReactSVG} from "react-svg";
import hstatic, {staticHypotheekbondUrl} from "@dnhb/content-api-client/src/util/hstatic";
import {LAYOUT_CONSTANTS} from "../const";
import {ButtonBase as Button} from "./Content";
import Link from "./Link";

const {FORM_ROW_PADDING} = LAYOUT_CONSTANTS;

interface Props {
  style?: {
    [key: string]: number|string|boolean;
  }
}

const BackToTopButton: React.FC<Props> = ({
  style
}) => {
  return (
    <Link
      to={null}
      className={"theme--secondary-color"}
      style={{
        width: 'inherit',
        marginBottom: FORM_ROW_PADDING,
        ...style
      }}
      onClick={() => {
        window.scrollTo(0, 0);
      }}
    >
      <Button
        tabIndex={-1}
        disabled={false}
        className={"f-7 fw-600"}
        style={{
          color: 'inherit',
          border: 0,
          justifyContent: 'flex-start'
        }}
      >
        <i
          className={"theme--bg-secondary-color theme--overlay-color"}
          style={{
            marginRight: '6px',
            width: '24px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            height: '24px',
            alignItems: 'cente',
          }}
        >
          <ReactSVG
            src={hstatic(`${staticHypotheekbondUrl()}images/icon/back.svg`)}
            style={{
              width: '6px',
              position: 'relative',
              top: '-1px',
              left: '-2.5px',
              transform: 'rotate(90deg)',
            }}
          />
        </i>

        Naar het begin
      </Button>
    </Link>
  );
}

export default BackToTopButton;
